<div class="modal-header">
  <button type="button" class="close" aria-label="Close" (click)="fechar()"><span
      aria-hidden="true">&times;</span></button>
  <h5 class="modal-title">{{descricao}}</h5>
</div>
<div class="form-group textarea-disabled-horizontal">
  <textarea rows="5" disabled [value]="observacao" class="form-control "></textarea>
</div>
